import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Pencil, Check } from 'lucide-react';
import Header from './components/Header';
import Hero from './components/Hero';
import Intro from './components/Intro';
import ProjectGrid from './components/ProjectGrid';
import Expertise from './components/Expertise';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Teams from './pages/Teams';
import './i18n';

const Home = () => (
  <main>
    <Hero />
    <Intro />
    <ProjectGrid />
    <Expertise />
    <Contact />
  </main>
);

function App() {
  const [isEditable, setIsEditable] = useState(false);

  useEffect(() => {
    // Toggle contentEditable on the body
    document.body.contentEditable = isEditable ? 'true' : 'false';
    // When editable, suppress link clicks to allow editing link text
    if (isEditable) {
      const preventLinkClick = (e: MouseEvent) => {
        if ((e.target as HTMLElement).closest('a')) {
          e.preventDefault();
        }
      };
      document.addEventListener('click', preventLinkClick);
      return () => document.removeEventListener('click', preventLinkClick);
    }
  }, [isEditable]);

  return (
    <div className="font-sans text-studio-text antialiased selection:bg-black selection:text-white">
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/teams" element={<Teams />} />
      </Routes>
      <Footer />

      {/* Edit Mode Toggle */}
      <button
        onClick={() => setIsEditable(!isEditable)}
        className={`fixed bottom-4 right-4 p-3 rounded-full shadow-lg transition-colors z-50 ${
          isEditable ? 'bg-green-600 text-white' : 'bg-black text-white hover:bg-gray-800'
        }`}
        title={isEditable ? "Finish Editing" : "Edit Text"}
      >
        {isEditable ? <Check size={20} /> : <Pencil size={20} />}
      </button>
    </div>
  );
}

export default App;
